import React, { useState } from "react";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import { X, CheckCircle, Video, Calendar, Clock } from "lucide-react";
import "./css/LandingStyle.css";

const secondaryAppConfig = {
  apiKey: "AIzaSyDsILOSKmO2GY7AwMIeZNjaUNkJhBttFag",
  authDomain: "hb-tec.firebaseapp.com",
  projectId: "hb-tec",
  storageBucket: "hb-tec.appspot.com",
  messagingSenderId: "416914585641",
  appId: "1:416914585641:web:179ca3a8da7047b1be8438",
  measurementId: "G-JRX3Y9QQ7F",
};

let secondaryApp;
let secondaryDb;

try {
  secondaryApp = initializeApp(secondaryAppConfig, "secondary");
  secondaryDb = getFirestore(secondaryApp);
} catch (error) {
  console.error("Error initializing secondary Firebase app:", error);
}

function BookDemoModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    secondaryContact: "",
    subject: "",
    message: "",
    meetingPlatform: "zoom",
    meetingTime: "",
    meetingDate: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!secondaryDb) {
      alert("Error: Database connection not available");
      return;
    }

    try {
      const collectionRef = collection(secondaryDb, "MedcoRequests");
      await addDoc(collectionRef, {
        ...formData,
        createdAt: serverTimestamp(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      });

      onClose();
      alert("Demo booking submitted successfully!");
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form. Please try again.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-container-wide"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Left Sidebar: Branding & Benefits */}
        <div className="modal-sidebar">
          <div className="sidebar-content">
            <span className="sidebar-tag">Med-CO Platform</span>
            <h3>Transform your practice in 15 minutes.</h3>
            <p>
              Our product specialists will walk you through the core modules
              designed to save you time.
            </p>

            <ul className="benefit-list">
              <li>
                <CheckCircle size={18} /> Smart Patient Scheduling
              </li>
              <li>
                <CheckCircle size={18} /> Automated Billing & Invoicing
              </li>
              <li>
                <CheckCircle size={18} /> Real-time Performance Analytics
              </li>
              <li>
                <CheckCircle size={18} /> Secure Health Records (EHR)
              </li>
            </ul>
          </div>
          <div className="sidebar-footer">
            <p>Trusted by healthcare providers worldwide.</p>
          </div>
        </div>

        {/* Right Area: The Form */}
        <div className="modal-form-area">
          <button className="close-btn-modern" onClick={onClose}>
            <X size={20} />
          </button>

          <div className="form-header">
            <h2>Book Your Demo</h2>
            <p>Fill out the details below and we'll handle the rest.</p>
          </div>

          <form onSubmit={handleSubmit} className="modern-grid-form">
            <div className="input-row">
              <div className="input-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="input-row">
              <div className="input-group">
                <input
                  type="text"
                  name="secondaryContact"
                  placeholder="Phone Number (Optional)"
                  value={formData.secondaryContact}
                  onChange={handleChange}
                />
              </div>
              <div className="input-group">
                <input
                  type="text"
                  name="subject"
                  placeholder="Clinic / Hospital Name"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="input-group">
              <textarea
                name="message"
                placeholder="Tell us about your specific needs..."
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <div className="selection-grid">
              <div className="select-wrapper">
                <select
                  name="meetingPlatform"
                  value={formData.meetingPlatform}
                  onChange={handleChange}
                  required
                >
                  <option value="zoom">Zoom</option>
                  <option value="teams">Teams</option>
                  <option value="meet">Google Meet</option>
                </select>
              </div>

              <div className="select-wrapper">
                <Calendar size={16} className="input-icon" />
                <input
                  type="date"
                  name="meetingDate"
                  value={formData.meetingDate}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="select-wrapper">
                <Clock size={16} className="input-icon" />
                <input
                  type="time"
                  name="meetingTime"
                  value={formData.meetingTime}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <button type="submit" className="modal-submit-btn">
              Confirm Schedule
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default BookDemoModal;
